import { cn, Divider, Stack, StackProps } from 'component-library';
import { ReactNode } from 'react';

export type CardItem = {
  text: string;
};

type CardBaseProps = { children?: ReactNode; showDivider?: boolean; className?: string } & StackProps;

export const CardLayout = ({ children, showDivider = false, className, ...props }: CardBaseProps) => {
  return (
    <>
      <Stack spacing={4} className={cn('p-6', className)} data-testid='card-atom-widget' {...props}>
        {children}
      </Stack>
      {showDivider && <Divider />}
    </>
  );
};
